import { ArrowUp, Github, Linkedin, Mail, Phone } from 'lucide-react';
import { profile } from '../../data/siteContent';
import { useApp } from '../../context/AppContext';

const socialLinks = [
  { label: 'LinkedIn', href: profile.linkedin, icon: Linkedin },
  { label: 'GitHub', href: profile.github, icon: Github },
  { label: 'Email', href: `mailto:${profile.email}`, icon: Mail },
  { label: 'Call', href: `#`, icon: Phone },
];

// Footer closes with essential links, location and a one-click return to the top.
export function Footer() {
  const { t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="page-shell footer-grid">
        <div>
          <a className="brand-mark" href="#top" aria-label="Afshin Zehtab — home">
            <img className="brand-logo brand-logo--light" src="/images/logo-back-on-white.png" alt="" />
            <img className="brand-logo brand-logo--dark" src="/images/logo-primary.png" alt="" />
          </a>
          <p>{t.footer.note}</p>
        </div>
        <div className="footer-socials">
          {socialLinks.map((social) => {
            const Icon = social.icon;
            return (
              <a href={social.href} target={social.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" aria-label={social.label} key={social.label}>
                <Icon size={17} /><span>{social.label}</span>
              </a>
            );
          })}
        </div>
        <a className="back-to-top" href="#top" aria-label={t.actions.top}><ArrowUp /></a>
      </div>
      <div className="page-shell footer-bottom">
        <p>© {year} {profile.fullName}. {t.footer.rights}</p>
        <p>48.1351° N · 11.5820° E</p>
      </div>
    </footer>
  );
}
